import Vue from 'vue'
import VueRouter from 'vue-router'
import { Auth } from 'aws-amplify'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/main-cluster',
  },
  {
    path: '/main-cluster',
    name: 'main-cluster',
    meta: {
      layout: 'main',
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/Cluster.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'auth',
    },
    props: true,
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/verify',
    name: 'verify',
    meta: {
      layout: 'auth',
    },
    props: true,
    component: () => import('../views/Verify.vue'),
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    meta: {
      layout: 'auth',
    },
    component: () => import('../views/ForgotPassword.vue'),
  },
]

if (process.env.VUE_APP_ONBOARDING === 'true') {
  routes.push(
    {
      path: '/onboarding',
      name: 'onboarding',
      meta: {
        layout: 'auth',
        requiresAuth: true,
      },
      component: () => import('../views/Onboarding.vue'),
    },
    {
      path: '/onboarding-status',
      name: 'onboarding-status',
      meta: {
        layout: 'auth',
        requiresAuth: true,
      },
      component: () => import('../components/OnboardingStatus.vue'),
    }
  )
}

routes.push({
  path: '*',
  redirect: '/main-cluster',
})

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    try {
      await Auth.currentAuthenticatedUser()
      next()
    } catch {
      next({ name: 'login' })
    }
  } else {
    next()
  }
})

export default router
